// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toastification-close-icon[data-v-7f5431ea],\n.toastification-title[data-v-7f5431ea] {\n  line-height: 26px;\n}\n.toastification-title[data-v-7f5431ea] {\n  color: inherit;\n}", ""]);
// Exports
module.exports = exports;
